import React from 'react';
import styled from 'styled-components';

import ROUTES from '@/common/routes';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { ScheduledContributionSummary } from '@/modules/employer/components/Contributions/ScheduledContribution';

const Wrapper = styled.div`
  width: 100%;
  margin-top: 0;
  min-height: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ScheduledContributionPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.CONTRIBUTIONS,
      title: 'Contributions',
    },
    {
      route: ROUTES.SCHEDULED_CONTRIBUTION_SUMMARY,
      title: 'Scheduled Contributions',
    },
  ]);
  return (
    <Wrapper>
      <Topbar />

      <ScheduledContributionSummary />
    </Wrapper>
  );
};

export default ScheduledContributionPage;
